export default __webpack_public_path__ + "css/taxEditor.bundle.css";